import { Component, Vue } from 'vue-property-decorator';
import WithRender from './team.html';
import VuePhoneNumberInput from "vue-phone-number-input";
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';

@WithRender
@Component({
  components: {
    VuePhoneNumberInput,
    Loading
  }
})
export default class Team extends Vue {

  selectedFile: any = null;
  mobileNumber = '';
  isLoading = false;
  form = {
    name: '',
    mobile: '',
    password:'',
    confirm:''
  }
  valideReceiverNumberMessage = '';

  ValidatePhoneNumber(payload: any) {
    if (payload.isValid) {
      this.valideReceiverNumberMessage = '';
      this.form.mobile = payload.countryCallingCode + payload.nationalNumber;
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  onSubmit(event: any) {
    event.preventDefault()
    this.isLoading = true;

    let dto = { fullName: this.form.name, mobile: this.form.mobile, password: this.form.password}

    _axios.post(config.gateway + "customerdata/user/team", dto,
      {
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent.loaded / progressEvent.total);
        },
      })
      .then((response) => {
        this.$router.push("callback?msg=" + response.data);
      })
      .catch((error) => {
        const err = error as any;
        if (err.response && err.response.status && err.response.status == '400')
          this.ErrorNotification(err.response.data, 'danger');
        else
          this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}
